import { store } from '../redux/store'
import { fold as foldContactFloating } from '../redux/contact-floating-slice'
import { open as openContactFormModal, close as closeContactFormModal } from '../redux/contact-form-modal-slice'
import { close as closeMainSearchTextbox } from '../redux/main-search-textbox-slice'
import { setSubmenu1Slug } from '../redux/main-submenu-slice'

/* Elements */
let bodyEl

const onDomContentLoaded = () => {
    /* Get elements */
    bodyEl = document.querySelector('body')

    /* On click on body, close things */
    bodyEl.addEventListener('click', onBodyClick)

    /* Some actions in response to hash */
    linkHashActions()

    /* Read hash and perform some actions */
    urlHashActions()

    /* On Store change */
    store.subscribe(onStoreChange)
}

const onBodyClick = (event) => {
    store.dispatch(foldContactFloating())
    store.dispatch(closeContactFormModal())
    store.dispatch(closeMainSearchTextbox())
    store.dispatch(setSubmenu1Slug(''))
}

const urlHashActions = () => {
    const hash = document.location.hash.replace(/^#/, '')
    switch (hash)
    {
        case 'contact-form-modal':
            store.dispatch(openContactFormModal())
            break
        default:
            break
    }
}

const linkHashActions = () => {
    const linkEls = document.querySelectorAll('[href*="#contact_form"]')
    for (const linkEl of linkEls)
    {
        const caseName = linkEl.hash.substr(1).replace('contact_form_', '')
        const payload = {
            case: caseName,
        }
        linkEl.addEventListener('click', (event) => {
            event.preventDefault()
            event.stopPropagation()
            store.dispatch(openContactFormModal(payload))
        })
    }
}

const onStoreChange = () => {
    const state = store.getState();
    if (state.mobileMenu.open) {
        bodyEl.classList.add('scroll-disabled')
    } else {
        bodyEl.classList.remove('scroll-disabled')
    }
}


document.addEventListener('DOMContentLoaded', onDomContentLoaded)

